import React from "react";
import Style from "../styles/text.module.scss";
const ParrafoComponent = (props) => {
  return (
    <h4
      className={`${Style.p} ${props.styleGroup}`}
      style={props.style} // 👈 aquí está la clave
    >
      {props.children}
    </h4>
  );
};
export default ParrafoComponent;
